import { Skeleton } from "@/components/ui/skeleton";

function PageSkeleton() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar placeholder */}
      <div className="h-16 border-b bg-background px-6 flex items-center justify-between">
        <Skeleton className="h-8 w-32" />
        <div className="flex items-center gap-4">
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>

      {/* Content area placeholder */}
      <main className="flex-grow pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page title */}
          <Skeleton className="h-8 w-64 mb-2" />
          <Skeleton className="h-4 w-96 mb-8" />

          {/* Content card placeholder */}
          <div className="rounded-lg border p-6 space-y-4">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-5/6" />
          </div>
        </div>
      </main>
    </div>
  );
}

export { PageSkeleton };
